import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { FormHelperService } from "../../../core/form-helper.service";

@Component({
    selector: 'reusable-merchant-template',
    templateUrl: './reusable-merchant-template.html',
    styleUrls: ['./reusable-merchant-template.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReusableMerchantTemplate),
            multi: true
        }],
    standalone: false
})
export class ReusableMerchantTemplate implements ControlValueAccessor, OnInit, OnDestroy {
    @Output() remove = new EventEmitter<void>();
    @Input() showRemove = false;
    
    form: UntypedFormGroup;
    valueChangesSub: Subscription;

    constructor(private fb: UntypedFormBuilder,
        public formHelper: FormHelperService,
    ) {
        this.form = this.fb.group({
            feeLabel: ['', [Validators.required]],
            feeDescription: ['', [Validators.required]],
            volume: ['', [Validators.required]],
            fees: [''],
            numberOfTransactions: ['', [Validators.required]],
            transactionRate: ['']
        });
    }

    get feeLabel() { return this.form.get('feeLabel'); }
    get feeDescription() { return this.form.get('feeDescription'); }
    get volume() { return this.form.get('volume'); }
    get fees() { return this.form.get('fees'); }
    get numberOfTransactions() { return this.form.get('numberOfTransactions'); }
    get transactionRate() { return this.form.get('transactionRate'); }
    ngOnInit(): void {
        this.valueChangesSub = this.form.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
        });
    }

    // ---- ControlValueAccessor ----

    onChange: any = () => { };
    onTouched: any = () => { };

    writeValue(value: any): void {
        if (value) {
            this.form.patchValue(value, { emitEvent: false });
        } else {
            this.form.reset({}, { emitEvent: false });
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        isDisabled ? this.form.disable() : this.form.enable();
    }

    ngOnDestroy(): void {
        this.valueChangesSub.unsubscribe();
    }
}